import _ from 'underscore';
import BaseCtrl from 'edge/platform/base/BaseCtrl';

var fn = function fn($scope, $q, LocaleService, GeoCodeService, TranslateService, claimViewModel) {
    var ctrl = Object.create(BaseCtrl);
    var newVehicle = {
        placeholder: true
    };

    ctrl.init = function () {
        $scope.claimVm = claimViewModel();
        $scope.vehicleIncidentsVm = $scope.claimVm.lobs.commercialAuto.vehicleIncidents;
        $scope.theftCodes = {
            'theftentire': _.findWhere($scope.claimVm.lossCause.aspects.availableValues, {
                code: 'theftentire'
            }),
            'theftparts': _.findWhere($scope.claimVm.lossCause.aspects.availableValues, {
                code: 'theftparts'
            })
        };
        $scope.vehicleIncidentsVm.forEach(function (vi) {
            vi.theft.value = _.values($scope.theftCodes).includes($scope.claimVm.lossCause.value);
        });
        $scope.vehicleIncidentsVm.forEach(function (vi) {
            vi.safeToDrive.value = false;
        });
    };

    ctrl.defineWatches = function () {
        $scope.$watch('fnol.newMapCenter', function (newCenter) {
            if (newCenter !== undefined) {
                var result = GeoCodeService.getGeoCodedAddr(newCenter.latitude, newCenter.longitude);
                $q.when(result, function (address) {
                    $scope.claimVm.lossLocation.value = address;
                });
            }
        }, true);
    };

    ctrl.getAvailableVehicles = function () {
        var result = $scope.vehicleIncident.value.availableVehicles();
        result.push(newVehicle);
        return result;
    };

    ctrl.vehicleName = function (vehicle) {
        return vehicle.placeholder ? TranslateService.instant('fnol.ca.directives.vehicle-incident.Other Vehicle') : vehicle.getDisplayName(TranslateService.instant('fnol.ca.directives.vehicle-incident.New Vehicle'));
    };

    ctrl.next = function (flowNextFn, form) {
        if (form.invalid) {
            if ($scope.fnol.lossLocationType === 'map') {
                $scope.fnol.lossLocationType = 'city_only';
            }
        }
        return flowNextFn($scope.claimVm);
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', '$q', 'LocaleService', 'GeoCodeService', 'TranslateService', 'claimViewModel'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/fnol/ca/controllers/CAGlassOrTheftDetailsCtrl.js
// module id = 1498
// module chunks = 0